export enum GraphType {
	Bar,
	Line,
	Pie,
}
